module.exports = __webpack_public_path__ + "img/button-app.08184ec8.png";